import probeSlice, { actions } from './reducer';
import * as thunkActions from './actions';

export const probeActions = { ...actions, ...thunkActions };
export * as ProbeTypes from './types';
export default probeSlice;
